export default __webpack_public_path__ + "static/media/transesophagaelecho.32fe04f5.pdf";